import { render, staticRenderFns } from "./VideoLinkage.vue?vue&type=template&id=103ff5b0&scoped=true"
import script from "./VideoLinkage.vue?vue&type=script&lang=js"
export * from "./VideoLinkage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103ff5b0",
  null
  
)

export default component.exports